import { Injectable } from '@angular/core';

@Injectable()
export class DateConverterService {
    constructor() {
        //
    }

    /**
     * @description Transforms a date string to a javascript date object.
     * @param string The string of a date.
     * @returns Date
     */
    public getDateObject($date: string): Date {
        try {
            const $bit = $date.split('T');
            const date: string = $bit[0];
            const time: string = $bit[1];
            return new Date(date.replace(/\-/g, '/') + ' ' + time);
        } catch ($exception) {
            console.error('Could not transform string to date', $date);
            return undefined;
        }
    }

    /**
     * @description Transforms a date object to a string supported by the database queries.
     * @param Date The date object to convert to string.
     * @returns string
     */
    public dateToDatabaseStringFormat($date: Date): string {
        let format: string;
        const month: number = $date.getMonth() + 1;
        const day: number = $date.getDate();
        format = $date.getFullYear() + '-';
        if ( month <= 9 ) {
            format += '0' + month + '-';
        } else {
            format += month + '-';
        }
        if ( day <= 9 ) {
            format += '0' + day;
        } else {
            format += day;
        }
        return format;
    }
}
